//* Public Interfaces
export interface AuthUser {
  name: string;
  email: string;
}

export const AUTH_CLAIM = {
  ROLES: 'https://kore.mx/roles',
  PERMISSIONS: 'permissions',
} as const;

export const AUTH_ROUTE_PATH = {
  LOGIN: 'login',
  NO_ROLE: 'sin-rol',
  NO_ACCESS: 'sin-acceso',
} as const;

export type AuthRoutePath = (typeof AUTH_ROUTE_PATH)[keyof typeof AUTH_ROUTE_PATH];

export interface LoginFeature {
  icon: string;
  title: string;
  description: string;
}

export const LOGIN_FEATURES: LoginFeature[] = [
  {
    icon: 'local_shipping',
    title: 'Entregas en tiempo real',
    description: 'Sigue cada cédula y cada pedido mientras sale a ruta.',
  },
  {
    icon: 'report_problem',
    title: 'Incidencias bajo control',
    description: 'Detecta no conformidades y atiéndelas a tiempo.',
  },
  {
    icon: 'insights',
    title: 'Indicadores claros',
    description: 'Mide cumplimiento y tiempos de entrega por día.',
  },
];
